export default __webpack_public_path__ + "static/media/330_dummy2016-yoga01-de.62e09990.png";